import { render } from "./RenderHtml.vue?vue&type=template&id=2cf18e9c"
import script from "./RenderHtml.vue?vue&type=script&lang=js"
export * from "./RenderHtml.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__